import React, { useCallback, useEffect, useRef, useState } from "react";
import CourseContentSideBar from "./CourseContentSideBar";
import ViewCourseDetail from "./ViewCourseDetail";
import QA from "./QA";
import Review from "./Review";
import { useDispatch } from "react-redux";
import { getCourseDetails } from "../../../features/slices/courseDetails";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import VideoPlayer from "../../VideoPlayer"
const initialState = {
  courseView: true,
  qa: false,
  review: false,
};
const CoursesDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [videoData, setVideoData] = useState("");
  const { courseView, qa, review } = iState;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const tabContentRef = useRef(null);
  const { courseDetails, loading } = useSelector(
    (state) => state?.courseDetails
  );
  const handleTab = (name) => {
    setUpdateState({
      courseView: false,
      qa: false,
      review: false,
      [name]: true,
    });
  };

  useEffect(() => {
    dispatch(getCourseDetails({ id: state?.id }));
    if (state.type == "QA") {
      setUpdateState((prevState) => ({
        ...prevState,
        courseView: false,
        qa: true,
        review: false,
      }));
      if (tabContentRef.current) {
        tabContentRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [state]);

  useEffect(() => {
    setVideoData(courseDetails?.result?.[0]?.courseMedia?.[0]?.video);
  }, [courseDetails]);
  const handleVideo = useCallback((vid) => {
    setVideoData(null);
    setTimeout(() => setVideoData(vid), 100);
  }, []);
  console.log({ courseDetails });

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        {courseDetails?.result?.map((res) => {
          return (
            <div className="row" key={res?._id}>
              <div className="col-lg-8">
                <div className="Small-Wrapper">
                  <figure>
                    {/* <video
                      key={videoData}
                      src={videoData}
                      controls
                      autoPlay
                      controlsList="nodownload"
                      style={{
                        width: "100%",
                        height: "331px",
                      }}
                    /> */}
                    <VideoPlayer
                      url={videoData}
                      divHeight={"500px"}
                      // divStyle={{
                      //   height: "100%",
                      // }}
                    />
                  </figure>
                  <div className="TitleBox">
                    <h4 className="Title">{res?.title}</h4>
                  </div>
                  <figure className="d-flex align-items-center">
                    <img
                      src={res?.teacherProfilePic}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <figcaption className="ml-2">
                      <h6>{res?.teacherName}</h6>
                    </figcaption>
                  </figure>
                  <h5>Supporting Documents</h5>
                  {res?.supportingDocuments?.map((doc) => {
                    return (
                      <figure
                        className="d-flex align-items-center"
                        key={doc?._id || doc?.url}
                      >
                        <a
                          href={doc?.url}
                          download
                          target="_blank"
                          rel="noreferrer"
                          className="d-flex align-items-center"
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "600",
                              color: "#dc3545",
                              background: "#fff",
                            }}
                          >
                            PDF
                          </div>
                        </a>
                        <figcaption className="ml-2">
                          <h6>{doc?.title}</h6>
                          <a
                            href={doc?.url}
                            download
                            target="_blank"
                            rel="noreferrer"
                          >
                            Download
                          </a>
                        </figcaption>
                      </figure>
                    );
                  })}
                  {/* <figure className="d-flex align-items-center">
                    <img
                      src={res?.teacherProfilePic}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <figcaption className="ml-2">
                      <h6>{res?.teacherName}</h6>
                    </figcaption>
                  </figure> */}
                  <div className="DetailsTabs">
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <a
                          onClick={() => handleTab("courseView")}
                          className={`nav-link ${courseView ? "active" : ""}`}
                        >
                          Course Details
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          onClick={() => handleTab("qa")}
                          className={`nav-link ${qa ? "active" : ""}`}
                        >
                          Q&amp;A
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          onClick={() => handleTab("review")}
                          className={`nav-link ${review ? "active" : ""}`}
                        >
                          Review
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" ref={tabContentRef}>
                    {courseView && <ViewCourseDetail res={res} />}
                    {qa && <QA courseId={state?.id} res={res} />}
                    {review && <Review res={res} />}
                  </div>
                </div>
              </div>
              <CourseContentSideBar res={res} handleVideo={handleVideo} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CoursesDetails;
